// S-21 — the ⌘K command-palette registry, extracted from ui-shell.tsx into a
// PURE DATA module (like placeholder-routes.ts / breadcrumb-map.ts) so the
// nav-coherence vitest can cross-check every palette route against the
// registered ROUTE_PATHS without importing the heavy app shell. ui-shell.tsx
// imports this — single source of truth, zero behavior change.
export interface Command {
  id: string;
  /**
   * S-FIX-BUNDLE-4 / R2-007 — کلیدِ i18n در namespaceِ `shell`، نه متنِ فارسی.
   * پالت (`ui-shell.tsx`) آن را با `t()` حل می‌کند، پس جست‌وجویِ کاربر هم
   * رویِ متنِ همان زبانِ جاری انجام می‌شود (fa و ar).
   */
  labelKey: string;
  icon: string;
  route?: string;
  action?: "theme-light" | "theme-dark";
  hintKey?: string;
}

export const COMMANDS: Command[] = [
  { id: "home", labelKey: "cmdk.item.home.label", icon: "home", route: "home", hintKey: "cmdk.item.home.hint" },
  { id: "dashboard", labelKey: "cmdk.item.dashboard.label", icon: "home", route: "dashboard" },
  { id: "classroom", labelKey: "cmdk.item.classroom.label", icon: "live", route: "classroom" },
  { id: "course", labelKey: "cmdk.item.course.label", icon: "book", route: "course" },
  { id: "calendar", labelKey: "cmdk.item.calendar.label", icon: "calendar", route: "calendar" },
  { id: "library", labelKey: "cmdk.item.library.label", icon: "folder", route: "library" },
  { id: "labs", labelKey: "cmdk.item.labs.label", icon: "flask", route: "labs" },
  { id: "recordings", labelKey: "cmdk.item.recordings.label", icon: "video", route: "recordings" },
  { id: "search", labelKey: "cmdk.item.search.label", icon: "search", route: "search" },
  { id: "community", labelKey: "cmdk.item.community.label", icon: "users", route: "community" },
  { id: "messages", labelKey: "cmdk.item.messages.label", icon: "chat", route: "messages" },
  { id: "inbox", labelKey: "cmdk.item.inbox.label", icon: "bell", route: "inbox" },
  { id: "officehours", labelKey: "cmdk.item.officehours.label", icon: "headset", route: "officehours" },
  { id: "assessment", labelKey: "cmdk.item.assessment.label", icon: "chip", route: "assessment" },
  { id: "submission", labelKey: "cmdk.item.submission.label", icon: "check", route: "submission" },
  { id: "transcript", labelKey: "cmdk.item.transcript.label", icon: "file", route: "transcript" },
  { id: "degree-audit", labelKey: "cmdk.item.degree-audit.label", icon: "target", route: "degree-audit" },
  { id: "registration", labelKey: "cmdk.item.registration.label", icon: "plus", route: "registration" },
  { id: "career", labelKey: "cmdk.item.career.label", icon: "bolt", route: "career" },
  { id: "financial-aid", labelKey: "cmdk.item.financial-aid.label", icon: "dollar", route: "financial-aid" },
  { id: "wellness", labelKey: "cmdk.item.wellness.label", icon: "shield", route: "wellness" },
  { id: "credential", labelKey: "cmdk.item.credential.label", icon: "cert", route: "credential" },
  { id: "alumni", labelKey: "cmdk.item.alumni.label", icon: "grad", route: "alumni" },
  { id: "hackathons", labelKey: "cmdk.item.hackathons.label", icon: "trophy", route: "hackathons" },
  { id: "honor-code", labelKey: "cmdk.item.honor-code.label", icon: "shield", route: "honor-code" },
  { id: "schools", labelKey: "cmdk.item.schools.label", icon: "grad", route: "schools" },
  { id: "faculty", labelKey: "cmdk.item.faculty.label", icon: "users", route: "faculty" },
  { id: "research", labelKey: "cmdk.item.research.label", icon: "flask", route: "research" },
  { id: "events", labelKey: "cmdk.item.events.label", icon: "live", route: "events" },
  { id: "pricing", labelKey: "cmdk.item.pricing.label", icon: "dollar", route: "pricing" },
  { id: "help", labelKey: "cmdk.item.help.label", icon: "headset", route: "help" },
  { id: "about", labelKey: "cmdk.item.about.label", icon: "globe", route: "about" },
  { id: "vista", labelKey: "cmdk.item.vista.label", icon: "spark", route: "vista" },
  { id: "instructor", labelKey: "cmdk.item.instructor.label", icon: "grad", route: "instructor" },
  { id: "authoring", labelKey: "cmdk.item.authoring.label", icon: "sparkle", route: "admin/course-content" },
  { id: "analytics", labelKey: "cmdk.item.analytics.label", icon: "chart", route: "analytics" },
  { id: "admin", labelKey: "cmdk.item.admin.label", icon: "settings", route: "admin" },
  { id: "regulation", labelKey: "cmdk.item.regulation.label", icon: "shield", route: "admin/regulation" },
  { id: "parent", labelKey: "cmdk.item.parent.label", icon: "users", route: "parent" },
  { id: "profile", labelKey: "cmdk.item.profile.label", icon: "user", route: "profile" },
  { id: "bookmarks", labelKey: "cmdk.item.bookmarks.label", icon: "star", route: "bookmarks" },
  { id: "achievements", labelKey: "cmdk.item.achievements.label", icon: "trophy", route: "achievements" },
  { id: "settings", labelKey: "cmdk.item.settings.label", icon: "settings", route: "settings" },
  // Primary public funnel: the REAL application form. Listed before the
  // /admissions demo tour so a search for «پذیرش» surfaces the real intake first.
  { id: "apply", labelKey: "cmdk.item.apply.label", icon: "shield", route: "apply", hintKey: "cmdk.item.apply.hint" },
  { id: "track", labelKey: "cmdk.item.track.label", icon: "search", route: "track", hintKey: "cmdk.item.track.hint" },
  // (the old /admissions demo command was dropped — that route now hard-redirects to /apply,
  //  so a separate "demo" entry would just be a mislabelled duplicate of «درخواست پذیرش».)
  { id: "login", labelKey: "cmdk.item.login.label", icon: "user", route: "login" },
  // Theme commands removed (D-2026-06-13): dark mode disabled for now.
];
